import { render, staticRenderFns } from "./trai-phieu-detail-item.vue?vue&type=template&id=5d492a26"
import script from "./trai-phieu-detail-item.vue?vue&type=script&lang=js"
export * from "./trai-phieu-detail-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports